import { CloseOutlined } from '@ant-design/icons';
import { Button, Form, UploadFile } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Upload, { UploadProps } from 'antd/lib/upload/Upload';
import { useState } from 'react';

const AddComment = ({
  quotationId,
  handleFileEvent,
  handleAddComment,
  setImg,
  selectedFile,
  setCmt,
  cmt,
  img
}: any) => {
  const [fileList, setFileList] = useState<UploadFile[] | any>();

  const handleChange: UploadProps['onChange'] = (info) => {
    let newFileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    newFileList = newFileList.slice(-5);

    // 2. Read from response and show file link
    newFileList = newFileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(newFileList);
    setImg(fileList);
  };
  const props = {
    onChange: handleChange,
    multiple: true
  };

  const removeItemIndex = (index: number) => {
    setFileList([
      ...fileList.filter(
        (selected: any) => fileList.indexOf(selected) !== index
      )
    ]);
    setImg([
      ...fileList.filter(
        (selected: any) => fileList.indexOf(selected) !== index
      )
    ]);
  };
  return (
    <Form
      layout="vertical"
      style={{ width: '100%', display: 'flex', gap: '10px', marginTop: '10px' }}
    >
      <div className="attachUp" style={{ marginBottom: '10px' }}>
        <div
          style={{
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <div style={{ marginBottom: '10px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <p style={{ marginBottom: '0px' }}>Customer’s attachments</p>
              <Form.Item
                name="files"
                rules={[
                  {
                    required: true,
                    message: 'file can not be empty'
                  }
                ]}
              >
                <Upload
                  {...props}
                  multiple
                  fileList={fileList}
                  accept=".png, .jpg, .jpeg"
                  maxCount={5}
                  showUploadList={false}
                >
                  <Button
                    style={{
                      background: '#3c3d5f',
                      border: 'none',
                      color: 'white',
                      borderRadius: '8px'
                    }}
                  >
                    Upload
                  </Button>
                </Upload>
              </Form.Item>
            </div>
          </div>
          {fileList?.map((item: any, index: number) => (
            <li key={index}>
              {item.name}
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => removeItemIndex(index)}
              >
                <CloseOutlined />
              </span>
            </li>
          ))}
        </div>
      </div>

      <Form.Item
        name="comment"
        rules={[
          {
            required: true,
            message: 'Comment can not be empty'
          },
          {
            max: 150,
            message: 'Character must be less than 150!'
          }
        ]}
        style={{ width: '100%' }}
      >
        <div className="commentCard" style={{ marginBottom: '10px' }}>
          <div
            className="wrapTitle"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <p>Seller comment</p>
          </div>
          <p className="descript" style={{ marginBottom: '0px' }}>
            <TextArea
              maxLength={150}
              onChange={(e) => {
                setCmt(e.target.value);
              }}
            />
          </p>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              marginTop: '10px'
            }}
          ></div>
        </div>
      </Form.Item>
    </Form>
  );
};

export default AddComment;
